import React from 'react';
import { Card, Row, Col, Statistic, Tabs, Table } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import api from '../services/api';

const StatsPage: React.FC = () => {
  const { data: summaryData, isLoading: summaryLoading } = useQuery(['statsSummary'], async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  });

  const { data: trendData } = useQuery(['statsTrend'], async () => {
    const response = await api.get('/admin/stats/trend');
    return response.data;
  });

  const { data: valetData } = useQuery(['statsValets'], async () => {
    const response = await api.get('/admin/stats/valets');
    return response.data;
  });

  const valetColumns = [
    { title: 'Lokaj', dataIndex: 'name', key: 'name' },
    { title: 'Ukończone', dataIndex: 'completedCount', key: 'completedCount' },
    { title: 'Średni czas (min)', dataIndex: 'avgCompletionTime', key: 'avgCompletionTime' },
  ];

  return (
    <div>
      <h1>Statystyki</h1>
      <Tabs items={[
        {
          key: 'summary',
          label: 'Podsumowanie',
          children: (
            <div>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                  <Card>
                    <Statistic title="Łączna liczba żądań" value={summaryData?.totalRequests || 0} loading={summaryLoading} />
                  </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Card>
                    <Statistic title="Ukończone" value={summaryData?.completedRequests || 0} loading={summaryLoading} />
                  </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Card>
                    <Statistic title="Wskaźnik ukończenia" value={summaryData?.completionRate || 0} suffix="%" loading={summaryLoading} />
                  </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Card>
                    <Statistic title="Średni czas realizacji" value={summaryData?.avgCompletionTime || 0} suffix="min" loading={summaryLoading} />
                  </Card>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                <Col xs={24} lg={12}>
                  <Card title="Żądania według dnia">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={trendData?.daily || []}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Bar dataKey="count" fill="#1890ff" />
                      </BarChart>
                    </ResponsiveContainer>
                  </Card>
                </Col>
                <Col xs={24} lg={12}>
                  <Card title="Trend żądań">
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={trendData?.trend || []}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Line type="monotone" dataKey="created" stroke="#1890ff" />
                        <Line type="monotone" dataKey="completed" stroke="#52c41a" />
                      </LineChart>
                    </ResponsiveContainer>
                  </Card>
                </Col>
              </Row>
            </div>
          ),
        },
        {
          key: 'valets',
          label: 'Analiza lokajów',
          children: (
            <Card title="Statystyki lokajów">
              <Table 
                dataSource={valetData || []} 
                columns={valetColumns} 
                rowKey="id" 
                pagination={false}
              />
            </Card>
          ),
        },
      ]} />
    </div>
  );
};

export default StatsPage;
